import React, { useEffect, useState } from 'react';
import {
    DURATION_UNIT,
    KPI_TEXT,
    PRODUCT_CATEGORY,
} from '../../../../../../data/enums';
import { api } from '../../../../../../shared/hooks/api';
import PageLoader from '../../../../../../shared/components/LoadingPage';
import { Kpi } from '../../../../../../data/entities';
import { ContentWrapper } from '../../../../../ProductOrder/single/Styled';
import { FilterBar } from './FilterBar';
import { BarComponent } from '../../../Content/BarChart';

const SUBTYPE_COLOR = {
    [PRODUCT_CATEGORY.BARREL]: {
        primaryColor: '#2096D9',
        secondaryColor: '#E4F3FB',
    },
    [PRODUCT_CATEGORY.VEHICLE]: {
        primaryColor: '#FFAB00',
        secondaryColor: '#FFF5E0',
    },
    [PRODUCT_CATEGORY.VESSEL]: {
        primaryColor: '#36B37E',
        secondaryColor: '#E7F8F1',
    },
};

const processData = (kpi: Kpi) => {
    return {
        ...kpi,
        name:
            kpi.duration_unit === 'MONTH'
                ? `Tháng ${kpi.duration}`
                : `Năm ${kpi.duration}`,
        [KPI_TEXT.CURRENT]: kpi.current_value,
        [KPI_TEXT.REMAINING]: kpi.target_value - kpi.current_value,
    };
};

export const CategoryBarChart = ({
    subType,
    setSubType,
}: {
    subType: PRODUCT_CATEGORY;
    setSubType: Function;
}) => {
    const currentYear = new Date().getFullYear();
    const [durationUnit, setDurationUnit] = useState<'MONTH' | 'YEAR'>('MONTH');
    const [{ data, error, isLoading, setLocalUrl }, fetchKpi] = api.get(
        `/kpi/?subtype=${subType}`,
        { duration_unit: durationUnit, duration: currentYear }
    );

    useEffect(() => {
        setLocalUrl(`/kpi/?subtype=${subType}`);
    }, [subType]);

    useEffect(() => {
        fetchKpi({ duration_unit: durationUnit, duration: currentYear });
    }, [durationUnit]);

    if (isLoading) return <PageLoader />;

    const processedData = data.map((kpi: Kpi) => processData(kpi));

    return (
        <ContentWrapper>
            <span
                style={{
                    fontSize: '22px',
                    fontWeight: 600,
                    fontFamily: 'Noto Sans',
                }}
            >
                KPI Danh mục năm {currentYear}
            </span>

            <FilterBar
                currentOption={subType}
                options={Object.values(PRODUCT_CATEGORY)}
                onChangeOption={(option: PRODUCT_CATEGORY) =>
                    setSubType(option)
                }
                dropdownMenuList={Object.values(DURATION_UNIT).map(
                    (value: any) => ({ text: value })
                )}
                selectedMenuItem={DURATION_UNIT[durationUnit]}
                onClickSelectMenuItem={(itemText: string) => {
                    const durationUnit =
                        Object.keys(DURATION_UNIT).find(
                            (key) =>
                                DURATION_UNIT[
                                    key as keyof typeof DURATION_UNIT
                                ] === itemText
                        ) || null;
                    setDurationUnit(durationUnit as any);
                }}
            />

            <BarComponent
                data={processedData}
                primaryColor={SUBTYPE_COLOR[subType].primaryColor}
                secondaryColor={SUBTYPE_COLOR[subType].secondaryColor}
            />
        </ContentWrapper>
    );
};
